export default {
    UPLOAD_VIDEO_REQUEST: 'SESSION_IMPORT_UPLOAD_VIDEO_REQUEST',
    UPLOAD_VIDEO_SUCCESS: 'SESSION_IMPORT_UPLOAD_VIDEO_SUCCESS',

    GET_SIGNED_URL_REQUEST: 'SESSION_IMPORT_GET_SIGNED_URL_REQUEST',
    GET_SIGNED_URL_SUCCESS: 'SESSION_IMPORT_GET_SIGNED_URL_SUCCESS',

    CREATE_SESSION_REQUEST: 'SESSION_IMPORT_CREATE_SESSION_REQUEST',
    CREATE_SESSION_SUCCESS: 'SESSION_IMPORT_CREATE_SESSION_SUCCESS',

    LOCATIONS_REQUEST: 'SESSION_IMPORT_LOCATIONS_REQUEST',
    LOCATIONS_SUCCESS: 'SESSION_IMPORT_LOCATIONS_SUCCESS',

    COURSES_REQUEST: 'SESSION_IMPORT_COURSES_REQUEST',
    COURSES_SUCCESS: 'SESSION_IMPORT_COURSES_SUCCESS',

    ALLOWED_FORMATS_REQUEST: 'SESSION_IMPORT_ALLOWED_FORMATS_REQUEST',
    ALLOWED_FORMATS_SUCCESS: 'SESSION_IMPORT_ALLOWED_FORMATS_SUCCESS',

    COURSE_SCENARIOS_REQUEST: 'SESSION_IMPORT_COURSE_SCENARIOS_REQUEST',
    COURSE_SCENARIOS_SUCCESS: 'SESSION_IMPORT_COURSE_SCENARIOS_SUCCESS',

    SCENARIOS_REQUEST: 'SESSION_IMPORT_SCENARIOS_REQUEST',
    SCENARIOS_SUCCESS: 'SESSION_IMPORT_SCENARIOS_SUCCESS',
    DISPOSE: 'SESSION_IMPORT_DISPOSE_STORE',
};
